import { useQuery } from '@tanstack/react-query';
import { ReactQueryKeys } from 'common/enums';
import { AxiosResponse } from 'axios';
import { CrmGuidResponse, CrmResponse, ResponseModel } from 'common/interfaces';
import { RequestStatuses } from '../../constants';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { poolCalendarRequestConfig } from 'request-config/pool-calendar/pool-calendar.request-config';
import { transformCrmResponse } from 'utils/transform-crm-response';

interface PersonForLocationsResponse {
  contactid: CrmGuidResponse;
  fullname: CrmResponse;
}

const modifyResponse = ({ data }: AxiosResponse<ResponseModel<PersonForLocationsResponse[]>>) => {
  if (data.level === RequestStatuses.Success) {
    return data.data.map(item => transformCrmResponse(item));
  }

  return [];
};

const useGetPersonsForLocations = (options: { enabled?: boolean } = {}) => {
  const { fetch } = useFetch<ResponseModel<PersonForLocationsResponse[]>>({
    loadingKey: 'useGetPersonsForLocations',
    isShowLoading: false,
    ...poolCalendarRequestConfig.getPersonsForStandorts()
  });

  const { data: personsForLocations } = useQuery({
    queryKey: [ReactQueryKeys.GetPersonsForLocations],
    queryFn: () => fetch(),
    select: modifyResponse,
    ...options
  });

  return {
    personsForLocations
  };
};

export default useGetPersonsForLocations;
